export default __webpack_public_path__ + "static/media/bg-03.328da1e6.jpg";